module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Введите название документа"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.row.fileName),
      callback: function($$v) {
        _vm.$set(_vm.row, "fileName", $$v)
      },
      expression: "row.fileName"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  }), _vm._v(" "), (!_vm.row.file) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleloadFile
    }
  }, [_vm._v("\n      Загрузить документ\n    ")]) : _c('span', [_c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm._f("path")(_vm.row.file)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteFile()
      }
    }
  }, [_vm._v("X")])])], 1), _vm._v(" "), _c('td', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateUpdated
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date"
    },
    on: {
      "change": _vm.dateUpdated
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v("\n    —\n    "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateUpdated
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRequiredInformationBookkeeping(_vm.row)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90ea741c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/BankRequirementBookkeeping.vue
// module id = 983
// module chunks = 0